// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from './btnPermission'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import router from './router'
import store from './vuex'
import i18n from './i18n/i18n'
import qs from 'qs'
import Vue2OrgTree from 'vue2-org-tree'

import '@/assets/common/common.css'
import common from '@/assets/common/common'
import directives from './assets/common/directives'
import global from '@/constants/Global.constants'
import axios from '@/request/http'
import api from '@/request/index'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'


Vue.use(Vue2OrgTree)
Vue.prototype.qs = qs
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$bus = new Vue();
Vue.use(VueLazyload,{
  preLoad: 1.3, // 预加载高度比例
  attempt: 3, // 尝试加载次数
});
Vue.prototype.$axios = axios
Vue.prototype.common = common
Vue.prototype.directives = directives
Vue.prototype.global = global
Vue.prototype.$api = api;

// const originalPush = router.push
// router.push = function push(location) {
//   return originalPush.call(this, location).catch(err => console.log(err))
// }
//  获取角色信息，根据用户权限动态加载路由
router.beforeEach(async(to, from, next) => {
  console.log('t0',to)
  if (store.getters.token && !to.query.token) {
    store.dispatch('setToken', store.getters.token)
    if (to.path === '/login' || to.path === '/modifyPassword') {
      next()
    } else {
      // to.name为news是放行，使得打开新闻页面不会跳转到main页面
      if (!store.getters.info.role && (to.name !== 'news' && to.name !== 'newsList')) {
        console.log('去主页',store.getters.info.role)
        !async function getAddRouters () {
          await store.dispatch('getInfo', store.getters.token)
          store.dispatch('setAllUser')
          // await store.dispatch('newRoutes')
          // await store.dispatch('initPermission')
          next()
        }()
      } else {
        console.log('去具体页面')
        // store.dispatch('getPermission', to.meta.menuId)
        let is404 = to.matched.length == 0
        if (is404) {
          next({path: '/404'})
          return false
        }
        next()
      }
    }
  } else {
    let token = to.query.token
    if(token){
      await store.dispatch('setToken', token)
      try {
        const res = await axios.post(global.BASE_URL + '/msi/base/acl/redis/staff',{
          data:{certificate:token,systemId:to.query.systemId?to.query.systemId:1,}
        },{headers:{certificate:token}})
        console.log(res,'res')
        if(res.data.code === '0000'){
          localStorage.setItem(
            'user',
            JSON.stringify(res.data.data)
          )
          localStorage.setItem('isMenu', false)
          if(!sessionStorage.getItem('token')){
            sessionStorage.setItem('token', token);
          }
          // 将 token 写入 sessionStorage 后，移除地址栏中的 token 参数
          const { token: _token, ...restQuery } = to.query || {}
          if(to.path){
            next({ path: to.path, query: restQuery, replace: true })
          }else{
            next({path:'/main'})
          }
          return false
        }
      } catch (e) {
        console.error('token登录请求失败', e)
      }
    }
    if(to.path === '/forgetPassword'){
        next()
        return false
    }
    if(to.path === '/register'){
        next()
        return false
    }
    if(to.path === '/modifyPassword'){
      next()
      return false
  }
    if (to.path === '/login') {
      next()
    }
    next({path: '/login'})

  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js